import Typography from "@mui/material/Typography";
import type { CodeDecoder, ScanMode } from "./scan";
import { ScannerSurface } from "./ScannerSurface";
import { useT } from "../../shared/i18n";

/**
 * The `/scan` page: the hidden page title plus the global scanner surface
 * (scanner-surface 01). The camera, fallback, resolution and result panels
 * live in the `global` preset (`GlobalPreset`), dispatched by `ScannerSurface`
 * alongside the dialog presets.
 */
export function ScanView({ decoder, mode = "both" }: { decoder?: CodeDecoder; mode?: ScanMode }) {
  const t = useT();

  return (
    <>
      {/* Scan has no visible content header (spec §3); the hidden title keeps
          the one-h1-per-view contract and gives the route a focus target. */}
      <Typography component="h1" variant="h6" tabIndex={-1} sx={VISUALLY_HIDDEN} data-testid="scan-title">
        {t("scanTitle")}
      </Typography>
      <ScannerSurface variant="global" decoder={decoder} mode={mode} />
    </>
  );
}

/**
 * Visually hidden but screen-reader and focus visible: the scan view's page
 * title, which the camera surface replaces visually (spec §3, §10).
 */
const VISUALLY_HIDDEN = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
  border: 0,
} as const;
